import { render, staticRenderFns } from "./AddRefCoverPanel.vue?vue&type=template&id=466d03e5&scoped=true&"
import script from "./AddRefCoverPanel.vue?vue&type=script&lang=js&"
export * from "./AddRefCoverPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddRefCoverPanel.vue?vue&type=style&index=0&id=466d03e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d03e5",
  null
  
)

export default component.exports